export class CredCard {


    public static isMasterCard(card: string): boolean {
        return card.replace(/\D+/g,'').length === 16 && /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}/.test(card)
    }

    public static isValidMasterBin(card: string): boolean {
        const MASTERCARD_RANGE = ['222100', '272099']
        const PARSED_CARD = parseInt(card.slice(0, 6))
        if (card.length < 6) {
            return false
        }

        const startRange = parseInt(MASTERCARD_RANGE[0])
        const endRange = parseInt(MASTERCARD_RANGE[1])
        return PARSED_CARD >= startRange && PARSED_CARD <= endRange
    }
}